module.exports = __webpack_public_path__ + "static/media/privacy-policy.b016d33b.pdf";